module.exports = __webpack_public_path__ + "static/img/empty-title.15869303.png";